import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { HelperService } from 'app/services';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-tire-detail',
  templateUrl: './tire-details.component.html',
  styleUrls: ['./tire-details.component.scss'],
  providers: [DialogService],
})
export class TireDetailsComponent implements OnInit {
  @ViewChild('imagesContent', { static: true }) imagesContent: ElementRef;
  isAdding: boolean = false;
  tire: any = {};
  usd: string = currency.USD;
  tireAttr: any = {
    warranty: { label: 'Warranty', value: '' },
    size: { label: 'Tire size', value: '' },
    maxSpeed: { label: 'Max speed', value: '' },
    vehicleType: { label: 'Vehicle', value: '' },
    sideWallStyle: { label: 'Side Wall Style', value: '' },
    speedRating: { label: 'Speed rating', value: '' },
    loadIndex: { label: 'Load index', value: '' },
    threadDesign: { label: 'Tread Design', value: '' },
    inflationPressure: { label: 'Inflation Pressure', value: '' },
    threadDepth: { label: 'Tread Depth', value: '' },
    wetTraction: { label: 'Wet Traction', value: '' },
    rimRange: { label: 'Rim Range', value: '' },
    utqg: { label: 'UTQG', value: '' },
    runFlat: { label: 'Run-flat', value: '' },
    partNumber: { label: 'Item #', value: '' },
  };
  singleImage: string = '';
  imagesArray: any[] = [];
  documentUrls: any[];
  config: any = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#ccc',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-search-plus',
      zoomOut: 'fal fa-search-minus',
      next: 'fas fa-caret-right',
      prev: 'fas fa-caret-left',
      fullscreen: 'fal fa-expand',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: true,
      prev: true,
    },
  };
  imageIndex: number = 0;
  hideCost: boolean = false;
  source: string = '';
  isOpenFromQuickTireLookup: boolean = false;
  isOpenFromRO: boolean = false;
  constructor(private dynamicDialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private dialogService: DialogService, private helperService: HelperService) {}

  ngOnInit() {
    const { tireDetails, hideCost, source, isOpenFromQuickTireLookup, isOpenFromRO } = this.dynamicDialogConfig.data;
    this.source = source;
    this.hideCost = hideCost;
    this.isOpenFromQuickTireLookup = isOpenFromQuickTireLookup;
    this.isOpenFromRO =  isOpenFromRO;
    this.tire = this.helperService.deepCopy(tireDetails);
    this.imagesArray =
      this.tire?.tireExtraImages?.map((image) => {
        return { imageSrc: image, active: false };
      }) || [];
    this.documentUrls = this.helperService.deepCopy(this.tire?.tireExtraImages) || [];
    this.tire.specifications = this.formatTireData(tireDetails);
    if (this.imagesArray?.length) {
      this.singleImage = this.imagesArray[0].imageSrc || this.tire?.image;
      this.imagesArray[0].active = true;
    } else {
      this.singleImage = this.tire?.image;
      this.imagesArray.push({ imageSrc: this.singleImage, active: true });
      this.documentUrls.push(this.singleImage);
    }
  }

  formatTireData(tireData: any) {
    const tireAttributes = Object.keys(this.tireAttr) || [];
    tireAttributes.forEach((attr: string) => {
      if (tireData[attr]) {
        if (attr === 'inflationPressure') {
          this.tireAttr[attr].value = tireData[attr] + ' PSI';
        } else if (attr === 'maxSpeed') {
          this.tireAttr[attr].value = tireData[attr] + ' mph';
        } else if (attr === 'warranty') {
          this.tireAttr[attr].value = tireData[attr] + ' miles';
        } else if (attr === 'rimRange') {
          this.tireAttr[attr].value = tireData[attr] + '"';
        } else {
          this.tireAttr[attr].value = tireData[attr];
        }
      }
    });

    return Object.values(this.tireAttr)?.filter((attr: any) => attr.value);
  }

  handleClose(isSuccess?: boolean, tire?: any) {
    this.dynamicDialogRef.close({ isSuccess, data: tire });
  }

  openAddToCartPopupModal() {
    this.handleClose(true, this.tire);
  }

  handleAddToRo(tire?: any) {}

  slideImage(action: string) {
    const index = this.imagesArray.findIndex((image) => image.active);

    if (action === 'next') {
      if (index > -1 && index + 1 < this.imagesArray.length) {
        this.imagesArray.forEach((image: any) => {
          image.active = false;
        });
        this.imagesArray[index + 1].active = true;
        this.singleImage = this.imagesArray[index + 1].imageSrc;
        this.imageIndex += 1;
      }
      setTimeout(() => {
        this.imagesContent.nativeElement.scrollLeft += 80;
      }, 5);
    } else {
      if (index > 0) {
        this.imagesArray.forEach((image: any) => {
          image.active = false;
        });
        this.imagesArray[index - 1].active = true;
        this.singleImage = this.imagesArray[index - 1].imageSrc;
        this.imageIndex -= 1;
      }
      setTimeout(() => {
        this.imagesContent.nativeElement.scrollLeft -= 80;
      }, 5);
    }
  }

  enlageImage(img: any, idx: number) {
    if (img) {
      this.imagesArray.forEach((image: any) => {
        image.active = false;
      });
      img.active = true;
      this.singleImage = img.imageSrc;
      this.imageIndex = idx;
    }
  }

  handleIndexChangeEvent(index: number) {
    if (index > this.imageIndex) {
      this.slideImage('next');
    } else {
      this.slideImage('prev');
    }
  }

  handleUpdateTireImage(imgContainer: HTMLImageElement) {
    try {
      imgContainer.src = 'assets/img/tireconnect-tire.png';
      document.querySelector('angular-image-viewer').querySelector('img').src = 'assets/img/tireconnect-tire.png';
    } catch (err) {
      console.log(err);
    }
  }
}
